var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxRocketLaunchOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90947 5.72235C5.28448 4.61373 3.76952 5.46 2.5 6.76327L5.30987 8.45582",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2786 9.09058C11.3873 10.7154 10.541 12.2302 9.23762 13.4996L7.54492 10.69",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 8.44755L7.55141 10.6902C9.34567 9.61541 11.3854 8.57449 12.3163 7.60973C14.3306 5.59559 13.1627 2.83673 13.1627 2.83673C13.1627 2.83673 10.4036 1.66887 8.3893 3.683C7.42446 4.61391 6.37499 6.66191 5.30859 8.44755Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54492 6.32324L9.67641 9.45447",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9642 5.46005C11.1979 5.46005 11.3874 5.2706 11.3874 5.03691C11.3874 4.80322 11.1979 4.61377 10.9642 4.61377C10.7305 4.61377 10.541 4.80322 10.541 5.03691C10.541 5.2706 10.7305 5.46005 10.9642 5.46005Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19138 12.6026C4.7005 13.0766 2.5 13.4997 2.5 13.4997C2.5 13.4997 2.92317 11.2994 3.39713 10.8085C3.51335 10.6839 3.6535 10.5838 3.80923 10.5144C3.96496 10.4451 4.13307 10.4078 4.30352 10.4047C4.47399 10.4017 4.64331 10.4331 4.80139 10.4969C4.95946 10.5607 5.10306 10.6558 5.22361 10.7764C5.34416 10.8969 5.4392 11.0405 5.50305 11.1986C5.5669 11.3566 5.59826 11.5259 5.59524 11.6964C5.59224 11.8668 5.55493 12.0349 5.48554 12.1906C5.41616 12.3463 5.31611 12.4864 5.19138 12.6026Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxRocketLaunchOutline);
export default __webpack_public_path__ + "static/media/icon_16px_rocket-launch_outline.c7732f96711eed48578101c32037cc41.svg";
export { ForwardRef as ReactComponent };